import { getEcoBadgeType } from "../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { EcoTagType, NewCarResultPromotionType } from "../../../../common-deprecated/types/CommonTypes";
import { getEcoBadgeUrl } from "../../../../common-deprecated/utils";
import { getEcoBonusPromotions } from "../../../../common-deprecated/utils/promotionUtils";
import type { ModelResultType } from "../../../../shared-logic/features/filters/utils/constants/resultConstants";
import { useModelFilterSelector } from "../redux/store";

type PropsType = {
    model: ModelResultType;
};

type ModelResultTagsReturnType = {
    modelIsAvailableForOnlineSale: boolean;
    modelIsAvailableForOnlineLeasing: boolean;
    modelIsSoldOut: boolean;
    ecoTags: Set<EcoTagType>;
    ecoBonus: NewCarResultPromotionType[];
    ecoBadgeUrls: string[];
};

const useModelResultTags = ({ model }: PropsType): ModelResultTagsReturnType => {
    const commonSettings = useModelFilterSelector((state) => state.commonSettings);

    const { id, cars, promotions } = model;

    // If the model has one/more then one grade that is availableForOnlineSales this needs to be shown.
    const modelIsAvailableForOnlineSale = cars.filter((car) => car.grade.availableForOnlineSales).length > 0;
    const modelIsAvailableForOnlineLeasing = cars.filter((car) => car.grade.availableForOnlineLeasing).length > 0;
    // if all cars are sold out, the model is sold out
    const modelIsSoldOut = cars.filter((car) => !car.soldOut).length === 0;

    // We check all the cars of the model and filter out the distinct ecoTags.
    const ecoTags = new Set(
        cars.filter((car) => Boolean(car.grade.ecoTag)).map((car) => car.grade.ecoTag as EcoTagType),
    );

    const ecoBonus = promotions ? getEcoBonusPromotions<NewCarResultPromotionType>(promotions, promotions) : [];

    const ecoBadgeUrls = [...ecoTags]
        .map((ecoTag) => {
            const ecoBadge = getEcoBadgeType(commonSettings, ecoTag, id);
            const ecoBadgeUrl = getEcoBadgeUrl(ecoBadge, commonSettings);
            return ecoBadgeUrl ?? null;
        })
        .filter((url) => url !== null);

    return {
        modelIsAvailableForOnlineSale,
        modelIsAvailableForOnlineLeasing,
        modelIsSoldOut,
        ecoTags,
        ecoBonus,
        ecoBadgeUrls,
    };
};

export default useModelResultTags;
